import { changeRemindRecord, signAgreement } from '@/http/service/mine'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      getUserRoles: 'mymanage/getUserRoles',
    }),
  },
  activated() {
    if(!this.unAutoLoadRemind) {
      this.getRemind()
    }
  },
  data() {
    return {
      remindList: [],
      rulesChangeRemindShow: false,
    }
  },
  methods: {
    /**
     * 获取修改协议列表
     */
    getRemind() {
      if(!this.$store.state.isLogin) return
      let channelType = 4 // 1:三翼鸟工作台,2:三翼鸟支付宝小程序,3:智家体验店小程序,4:M站,5:三翼鸟APP,6:智家APP,7:商家中心 8:内购频道
      if(this.$util.isShopKeeper()) {
        channelType = 1
      }else if(this.$util.isSyBird()) {
        channelType = 5
      }else if(this.$util.isUplus()) {
        channelType = 6
      }else if (this.$util.isInternalChannel()) {
        channelType = 8
      }
      let identify = this.getUserRoles?.size ? Array.from(this.getUserRoles)[0] : '001'
      const params = {
        identify,
        channelType,
      }
      changeRemindRecord(params).then(res =>{
        if(res?.data?.success){
          if( res?.data?.data){
            this.remindList = res?.data?.data
            this.rulesChangeRemindShow = true
          }else if(this.unAutoLoadRemind) {
            this.afterSign()
          }
        }else {
          this.$toast(res?.data?.msg)
          if(this.unAutoLoadRemind) {
            this.afterSign()
          }
        }
      }).catch(err => {
        console.log(err)
        this.$toast(err.message)
        if(this.unAutoLoadRemind) {
          this.afterSign()
        }
      })
    },
    /**
     * 签订协议
     */
    confirm() {
      let source = 2
      if(this.$util.isShopKeeper()) {
        source = 1
      }else if(this.$util.isScMpPeWechat()) {
        source = 3
      }else if(this.$util.isScMpAli()) {
        source = 4
      } else if (this.$util.isInternalChannel()) {
        source = 8
      }
      let tempArr = []
      this.remindList.forEach(item => {
        tempArr.push(item.id)
      })
      let content = tempArr.join(',')
      const params = {
        source,
        richTextId: '',
        module: 3,
        content,
      }
      signAgreement(params).then(res => {
        if(res?.data?.success && res?.data?.data) {
          this.rulesChangeRemindShow = false
          if(this.unAutoLoadRemind) {
            this.afterSign()
          }
        }else {
          this.$toast(res?.data?.msg)
        }
      }).catch(err => {
        console.log(err)
        this.$toast(err.message)
      })
    },
    /**
     * 取消
     */
    cancle() {
      this.rulesChangeRemindShow = false
      if(this.$util.isShopKeeper() || this.$util.isSyBird() || this.$util.isUplus()) {
        // 关闭弹窗
      }else if(this.$util.isInternalChannel()) {
        // 内购频道，关闭容器
        this.closeWebview()
      }else {
        // 其他情况，退出登录
        this.$store.dispatch('logout').then(res => {
          if(this.$route.name != 'home') {
            this.$store.dispatch('doLogin')
          }
        })
      }
    },

    /**
     * 关闭容器
    */
    async closeWebview() {
      try {
        let ihaierSDK = await this.$util.initLarkEnv()
        const closeRes = ihaierSDK?.navigation?.close()
        console.log('closeRes======111=======>', closeRes)
      } catch (err) {
        console.log('closeWebview error==================>', err);
      }
    },
  }
}


